import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COOKIE_CONSENT_KEY, setAnalyticsConsent } from "../firebase";
import { setMetaPixelConsent } from "../metaPixel";

const readChoice = () => {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch (error) {
    return null;
  }
};

const CookieConsent = () => {
  const [choice, setChoice] = useState(readChoice);
  const [open, setOpen] = useState(() => !readChoice());

  useEffect(() => {
    const syncChoice = () => setChoice(readChoice());
    const openSettings = () => setOpen(true);
    window.addEventListener("circlegrid-cookie-consent", syncChoice);
    window.addEventListener("circlegrid-open-cookie-settings", openSettings);
    return () => {
      window.removeEventListener("circlegrid-cookie-consent", syncChoice);
      window.removeEventListener(
        "circlegrid-open-cookie-settings",
        openSettings,
      );
    };
  }, []);

  const saveChoice = (allowAnalytics) => {
    setAnalyticsConsent(allowAnalytics);
    setMetaPixelConsent(allowAnalytics);
    setChoice(allowAnalytics ? "analytics" : "essential");
    setOpen(false);
  };

  if (!open) {
    return null;
  }

  return (
    <section
      role="dialog"
      aria-modal="true"
      aria-label="Cookie choices"
      style={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 9999,
        maxWidth: 720,
        margin: "0 auto",
        padding: 20,
        borderRadius: 12,
        background: "#ffffff",
        color: "#1f2937",
        boxShadow: "0 14px 40px rgba(15, 23, 42, 0.3)",
        border: "1px solid #cbd5e1",
        textAlign: "left",
      }}
    >
      <h2 style={{ margin: "0 0 8px", fontSize: 20 }}>Cookie choices</h2>
      <p style={{ margin: "0 0 16px", lineHeight: 1.5 }}>
        Essential storage keeps CircleGrid secure and remembers your choices.
        With your permission, analytics help us improve the service and measure
        whether our ads work. Analytics stays off unless you select “Accept
        analytics”. Read our{" "}
        <Link to="/TermsAndConditions#privacy">privacy notice</Link>.
      </p>
      {choice && (
        <p style={{ margin: "0 0 12px", fontSize: 13, color: "#475569" }}>
          Current choice: {choice === "analytics" ? "analytics accepted" : "essential only"}.
        </p>
      )}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={() => saveChoice(false)}
          style={{ padding: "10px 16px", borderRadius: 8, border: "1px solid #64748b", background: "white" }}
        >
          Essential only
        </button>
        <button
          type="button"
          onClick={() => saveChoice(true)}
          style={{ padding: "10px 16px", borderRadius: 8, border: 0, background: "#047857", color: "white" }}
        >
          Accept analytics
        </button>
      </div>
    </section>
  );
};

export default CookieConsent;
